import { animateDetailsToggle, cssInterpolatesHeight, motionAllowed } from '@theme/r-motion';

// ↗ .cursor/references/code-notes/r-disclosure.js.md#§1
if (!cssInterpolatesHeight) {
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !motionAllowed()) return;
    const summary = event.target.closest('details.r-disclosure > summary');
    const details = summary?.parentElement;
    if (!(details instanceof HTMLDetailsElement) || !details.querySelector(':scope > .r-disclosure__panel')) return;
    event.preventDefault();
    animateDetailsToggle(details);
  });
}
